import { render, staticRenderFns } from "./IButtons.vue?vue&type=template&id=f9d615c2&scoped=true&"
import script from "./IButtons.vue?vue&type=script&lang=js&"
export * from "./IButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d615c2",
  null
  
)

export default component.exports